import { render } from "./ItensNFUpdate.vue?vue&type=template&id=00b0f0b4&scoped=true"
import script from "./ItensNFUpdate.vue?vue&type=script&lang=js"
export * from "./ItensNFUpdate.vue?vue&type=script&lang=js"

import "./ItensNFUpdate.vue?vue&type=style&index=0&id=00b0f0b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b0f0b4"]])

export default __exports__